import React, { useState } from "react";
import User from "../api/user";
import AppBar from "../components/AppBar";
import AppBottomNavigation from "../components/BottomNavigation";
import Bookings from "./Bookings";
import Calendar from "./Calendar";
import Catalog from "./Catalog";
import ActionModal from "../components/ActionModal";
import { Box } from "@mui/material";
import { setMembers } from "../redux/actions";
import { useDispatch, useSelector } from "react-redux";

const Home = () => {
  const { user } = useSelector(({ slice }) => slice?.value);
  const { GetByCompany } = User || {};
  const [localProps, setLocalProps] = useState({
    isLoading: true,
    screen: 0,
  });
  const [screenIndex, setScreenIndex] = useState(0);

  const dispatch = useDispatch();
  const bookingsColumnDefs = {
    Standard: [
      "contractType",
      "internId",
      "createdAt",
      "createdBy",
      "checker",
      "startDay",
      "stopDay",
      "customer",
      "nature",
      "brand",
      "model",
      "departureAgency",
      "bookingStatus",
      "comment",
    ],
    Planning: [
      "shortId",
      "createdBy",
      "customer",
      "nature",
      "brand",
      "model",
      "createdAt",
      "startDay",
      "stopDay",
    ],
    Compteur: [
      "internId",
      "createdAt",
      "startDay",
      "customer",
      "nature",
      "brand",
      "model",
      "contractType",
      "realCounter",
    ],
    Type_contrat: [
      "shortId",
      "createdAt",
      "startDay",
      "stopDay",
      "customer",
      "nature",
      "brand",
      "model",
      "discount",
      "contractType",
      "realCounter",
    ],
    Facturation: [
      "shortId",
      "bookingStatus",
      "billId",
      "createdAt",
      "createdBy",
      "startDay",
      "stopDay",
      "customer",
      "nature",
      "brand",
      "model",
      "internId",
      "comment",
      "contractType",
      "realCounter",
      "netPrice",
    ],
    Export: [
      "shortId",
      "internId",
      "createdAt",
      "createdBy",
      "startDay",
      "stopDay",
      "customer",
      "nature",
      "brand",
      "model",
      "departureAgency",
      "bookingStatus",
      "comment",
      "discount",
      "contractType",
      "realCounter",
      "billId",
    ],
  };

  const machinesColumnDefs = {
    Standard: [
      "interactionRenderer",
      "image",
      "internId",
      "nature",
      "brand",
      "model",
      "designation",
      "serialNumber",
      "agency",
      "status",
      "openedCustomer",
    ],
    Calendrier: [
      "interactionRenderer",
      "image",
      "internId",
      "nature",
      "brand",
      "model",
      "designation",
      "serialNumber",
      "availableStartDate",
      "availableEndDate",
      "rentalRatioInDays",
      "allRentalDays",
    ],
    Compteur: [
      "interactionRenderer",
      "image",
      "internId",
      "serialNumber",
      "nature",
      "brand",
      "model",
      "year",
      "lastCounter",
      "lastFuelLevel",
      "periodicGeneralInspection",
      "warrantyExpiresOn",
    ],
    Export: [
      "image",
      "nature",
      "brand",
      "model",
      "internId",
      "serialNumber",
      "year",
      "status",
      "openedCustomer",
      "availableStartDate",
      "availableEndDate",
      "agency",
      "lastDepartureAgency",
      "dayPrice",
      "unityPrice",
      "lastCounter",
      "lastFuelLevel",
      "rentalRatioInDays",
      "allRentalDays",
      "group",
      "minIncome",
    ],
    "Modèle d'import": [
      "internId",
      "category",
      "brand",
      "model",
      "year",
      "serialNumber",
      "valuePrice",
      "bondPrice",
      "agency",
      "designation",
      "dayPrice",
      "unityPrice",
      "picture",
      "group",
      "distanceDeliveryPrice",
      "availableStartDate",
      "availableEndDate",
      "periodicGeneralInspection",
      "guidanceAntennaModel",
      "guidanceAntennaSerial",
      "guidanceScreenModel",
      "guidanceScreenSerial",
      "warrantyExpiresOn",
      "minIncome",
    ],
    Prix: [
      "interactionRenderer",
      "image",
      "internId",
      "nature",
      "brand",
      "model",
      "designation",
      "serialNumber",
      "dayPrice",
      "unityPrice",
      "status",
    ],
  };

  const constructor = async () => {
    const { token } = user || {};
    let { data: _members, status } = await GetByCompany({ token });
    dispatch(
      setMembers(
        _members?.sort((a, b) => (a?.firstName > b?.firstName ? 1 : -1))
      )
    );
    status === 200 &&
      setLocalProps({
        ...localProps,
        isLoading: false,
      });

    const agGridConfig = JSON.parse(localStorage.getItem("agGridConfig"));

    localStorage.setItem(
      "agGridConfig",
      JSON.stringify({
        booking: {
          columnDefs: agGridConfig?.booking?.columnDefs || bookingsColumnDefs,
          viewDefs: agGridConfig?.booking?.viewDefs || [
            "Standard",
            "Planning",
            "Compteur",
            "Type_contrat",
            "Facturation",
            "Export",
          ],
        },
        machine: {
          columnDefs: agGridConfig?.machine?.columnDefs || machinesColumnDefs,
          viewDefs: agGridConfig?.machine?.viewDefs || [
            "Standard",
            "Compteur",
            "Calendrier",
            "Prix",
            "Export",
            "Modèle d'import",
          ],
        },
      })
    );
  };

  localProps.isLoading && constructor();

  const screens = {
    0: <Calendar user={user} />,
    1: <Catalog />,
    2: <Bookings />,
    // 2: <InAndOut />,
  };

  // useEffect(() => constructor(), [screenIndex]);

  return (
    <>
      <Box
        style={{ position: "sticky", zIndex: 10, top: 0, right: 0, left: 0 }}
      >
        <AppBar />
      </Box>
      {screens[screenIndex]}
      <AppBottomNavigation
        screenIndex={screenIndex}
        setScreenIndex={(index) => setScreenIndex(index)}
      />
      <ActionModal />
    </>
  );
};
export default Home;
